import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap } from "react-leaflet";
import { useEffect } from "react";
import { SUBURBS } from "@/lib/site";

const SYDNEY_CENTRE = [-33.88, 151.05];

function AutoFitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    const bounds = points.map((p) => p.coords);
    map.fitBounds(bounds, { padding: [60, 60] });
  }, [map, points]);
  return null;
}

export default function MapEmbed({ height = 460 }) {
  const points = SUBURBS.filter((s) => Array.isArray(s.coords));

  return (
    <div
      className="overflow-hidden rounded-2xl border border-slate-200 shadow-sm"
      data-testid="map-embed"
      style={{ height }}
    >
      <MapContainer
        center={SYDNEY_CENTRE}
        zoom={11}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
          maxZoom={19}
        />
        <AutoFitBounds points={points} />
        {points.map((s) => (
          <CircleMarker
            key={s.slug}
            center={s.coords}
            radius={8}
            pathOptions={{
              color: "#ffffff",
              weight: 3,
              fillColor: "#2563EB",
              fillOpacity: 1,
            }}
          >
            <Tooltip
              permanent
              direction="right"
              offset={[8, 0]}
              className="fg-map-tooltip"
              opacity={1}
            >
              {s.name}
            </Tooltip>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}
